define.alias("shared/utils/plans-data/index", "calendar/utils/plans-data");